"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.common_es_es = void 0;
function common_es_es() {
    return {
        "actions.close": "cerrar",
        "actions.save": "salvar",
        "actions.cancel": "cancelar",
        "actions.create": "crear",
        "actions.yes": "sí",
        "actions.no": "no",
        "actions.add": "agregar",
        "actions.edit": "editar"
    };
}
exports.common_es_es = common_es_es;
